<template>
  <header class="main-header">
    <!-- Logo -->
    <a href="/" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><b></b>SSP</span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><b>Financeiro</b></span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav perfil" >
          <li class="dropdown user user-menu ">
            <b-button variant="link" @click="$store.commit('setAlertAtualizacoes', {show: true, status: true, msg: ''})">
              <b-icon icon="bell" class="atualizacoes"/>
            </b-button>
          </li>
          <li class="dropdown user user-menu">
            <a v-on:click="getCalendario()" href="#" class="icon-margin-top sigla-nome-usuario" data-toggle="dropdown">
              <b-button class="calendario">
                <b-icon icon="calendar3"></b-icon>
              </b-button>
            </a>
            <ul class="dropdown-menu dropdown-calendario">
                  <b-list-group>
                    <b-list-group-item variant="info"><strong>Extra contratual (mês corrente)</strong></b-list-group-item>
                    <b-list-group-item variant="light">Ciclo de pagamento do dia 21 a 20 de cada mês.</b-list-group-item>
                    <b-list-group-item variant="light">Até dia 25 - Fornecedor envia informações para o fop.</b-list-group-item>
                    <b-list-group-item variant="light">De 25 ao 2º dia útil do mês - Fop envia pagamento para matriz.</b-list-group-item>
                    <b-list-group-item variant="light">Do 2º dia útil ao dia 10 – Matriz cria PC.</b-list-group-item>
                    <b-list-group-item variant="info"><strong>SLA (mês anterior)</strong></b-list-group-item>
                    <b-list-group-item variant="light">Dia 8 – Fechamento SLA SSP.</b-list-group-item>
                    <b-list-group-item variant="light">Dia 8 ao dia 15 – Fop envia notificação para o fornecedor.</b-list-group-item>
                    <b-list-group-item variant="light">Até dia 25 – Fornecedor envia de acordo para multa/glosa.</b-list-group-item>
                    <b-list-group-item variant="light">De 25 ao 2º dia útil do mês - Fop envia multa/glosa para matriz. (Carta informando o mês do SLA (ex.: junho) e o mês do desconto (ex.: julho)).</b-list-group-item>
                  </b-list-group>
            </ul>
          </li>

          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle perfil" data-toggle="dropdown">
              <!-- <img src="~admin-lte/dist/img/user2-160x160.jpg" class="user-image" alt="User Image"> -->
              <div class="sigla-nome-usuario">
                <p>{{siglaNomeUsuario}}</p>
              </div>
              <span class="hidden-xs">{{ this.$store.state.login.loginUsuario.usuario.name }}</span>
            </a>

            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <div class="sigla-nome-usuario sigla-nome-usuario-dropdown-menu">
                  <p>{{siglaNomeUsuario}}</p>
                </div>

                <p>
                  {{ this.$store.state.login.loginUsuario.usuario.name }}
                  {{ (this.$store.state.login.loginUsuario.grupo.length !== 0) ? this.$store.state.login.loginUsuario.grupo.nome : 'Sem grupo definido'}}
                </p>
                  <div class="grupos-usuario">
                  <!-- <p v-for="i in grupo">{{'- ' + i.nome[0].toUpperCase() + i.nome.substring(1)}}</p> -->
                  <p v-for="i in grupo">{{i.nome[0].toUpperCase() + i.nome.substring(1) + ';'}} &nbsp; </p>
                  </div>
              </li>

              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <a href="#" class="btn btn-default btn-flat" v-on:click="irPara('/perfilusuario')">Perfil do usuário</a>
                </div>
                <div class="pull-right">
                  <a href='javascript:void(0)' class="btn btn-default btn-flat" v-on:click="irPara('/Logout')">Sair</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import AlertAlteracoes from './components/modal/AlertAtualizacoes.vue'

export default {
  data () {
    return {
      calendario: false,
      grupo: this.$store.state.login.loginUsuario.grupo
    }
  },
  components: {
    'alert-alteracoes': AlertAlteracoes
  },
  name: 'va-navibar',
  mounted () {
  },
  computed: {
    ...mapGetters([
      'unreadMessagesCount',
      'unreadNotificationsCount',
      'remainTasksCount',
      'currentUser'
    ]),
    siglaNomeUsuario: function () {
      let siglaNome = []
      let nome = this.$store.state.login.loginUsuario.usuario.name
      let nomeArray = nome.split(' ')
      for (let i in nomeArray) {
        siglaNome.push(` ${nomeArray[i][0]}`)
      }

      let siglaNome1 = siglaNome.toString().replace(',', '').replace(',', '')
      if (nomeArray.length >= 4) {
        return siglaNome1.substring(0, 6)
      } else {
        return siglaNome1
      }
    }
  },
  methods: {
    irPara: function (rota) {
      this.$router.push(rota)
    },
    getCalendario: function () {
      this.calendario = true
    }
  }
}

</script>
<style scoped>
  .icon-margin-top {
    margin: 10px;
  }
  .dropdown-calendario-left{
    padding-right: 2px;
  }
  .dropdown-calendario-right {
    padding-left: 2px;
  }
  .calendario {
    background-color: #3c8dbc;
  }
  .dropdown-calendario {
    width: 500px !important;
  }
  .sigla-nome-usuario {
    width: 3.3em;
    height: 3.3em;
    background-color: #337ab7;
    border: 1px solid #ddd;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 50%;
    font-size: 0.7em;
    margin-right: .5em;
    color: #fff;
  }
  .sigla-nome-usuario p {
      margin: unset;
  }
  .perfil {
    display: flex;
    align-items: center;
  }
  .sigla-nome-usuario-perfil {
    width: 5em;
    height: 5em;
    border: 1px solid #FFF;
    color: #FFF;
  }
 .sigla-nome-usuario-dropdown-menu {
    width: 3.5em;
    height: 3.5em;
    font-size: 1.5em;
    margin: auto;
  }
  .navbar-nav > li > a {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .user-header {
    display: flex;
    flex-direction: column;
  }
  .grupos-usuario {
    display: flex;
    color: white;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 1.02em;
  }

  .dropdown-frame {
    min-width: 65vw;
  }

  @media only screen and (max-width: 767px) {
    .dropdown-frame {
      min-width: 100vw;
    }
  }

  .atualizacoes {
      color: azure;
  }
  .atualizacoes:hover {
    color: black;
    opacity: 0.7;
  }
</style>



// WEBPACK FOOTER //
// NaviBar.vue?2ac31f2d